import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../../Components/CSS/FilterStyle.css";

class DriverFilter extends Component {
  render() {
    const { classes, data, handleSearch } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="fullName"
            type="text"
            label="Driver Number"
            variant="outlined"
            margin="normal"
            placeholder="Search by driver's Number"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.fullName}
            onChange={handleSearch}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(DriverFilter);
